/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */
'use strict';

function guid(): string {
  return 'g' + Math.random().toString(16).substr(2);
}

module.exports = guid;



/** WEBPACK FOOTER **
 ** /Users/dan/p/react-devtools/utils/guid.js
 **/